import { render, staticRenderFns } from "./AttributeReferenceTabButton.vue?vue&type=template&id=52aa9f5a&scoped=true&"
import script from "./AttributeReferenceTabButton.vue?vue&type=script&lang=ts&"
export * from "./AttributeReferenceTabButton.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeReferenceTabButton.vue?vue&type=style&index=0&id=52aa9f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa9f5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
